import { createContext, useContext, useEffect, useState } from "react";

const CoinlistContext = createContext();

export function CoinlistProvider({ children }) {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadCoinlist() {
      try {
       const res = await fetch(process.env.REACT_APP_COINLISTGETAPI);
        if (!res.ok) throw new Error("Failed to load coinlist");
        const data = await res.json();
        setCoins(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    loadCoinlist();
  }, []);

  return (
    <CoinlistContext.Provider value={{ coins, loading, error }}>
      {children}
    </CoinlistContext.Provider>
  );
}

export function useCoinlist() {
  return useContext(CoinlistContext);
}
